<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import AddEdit from "./addedit.vue";
import news from "@/models/news";

export default {
  mixins: [apibtoast, apigeneric, news],
  page: {
    title: "Talep",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    AddEdit,
  },
  data() {
    return {
      title: this.$t("news.Title"),
      items: [
        {
          text: this.$t("news.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("news.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("news.Title"),
          active: true,
        },
      ],

      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },

      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      FilterTitle: "",
    };
  },
  methods: {
    Get() {
      this.ActionsFilterGet({
        Service: "News",
        Page: this.Page,
        Filter: "&Title=" + this.FilterTitle+
        "&Websiteid="+window.$cookies.get("website")
      }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4">
                  <div class="search-box me-2 mb-2 d-inline-block">
                    <div class="position-relative">
                      <input
                        type="text"
                        @input="
                          FilterTitle.length >= 3 || FilterTitle.length == 0
                            ? Get()
                            : ''
                        "
                        v-model="FilterTitle"
                        class="form-control"
                        :placeholder="$t('news.Page.Arama')"
                      />
                      <i class="bx bx-search-alt search-icon"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                    <button
                      type="button"
                      class="btn btn-primary btn-rounded mb-2 me-2"
                      v-b-modal.news
                      @click="(DataUpdate = newsData), (AddEdit = 'Add')"
                    >
                      <i class="mdi mdi-plus me-1"></i
                      >{{ $t("news.Page.YeniKayitEkle") }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>{{ $t("news.Table.Title") }}</th>
                      <th>{{ $t("news.Table.Startdate") }}</th>
                      <th>{{ $t("news.Table.Enddate") }}</th>
                      <th>{{ $t("news.Table.LightBox") }}</th>

                      <th style="width: 100px; text-align: center">
                        {{ $t("news.Table.Islem") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <td>{{ Data.Title }}</td>
                      <td>{{ Data.Startdate | formatDateTime }}</td>
                      <td>{{ Data.Enddate | formatDateTime }}</td>
                      <td
                        style="
                          width: 90px;
                          text-align: center;
                          vertical-align: middle;
                        "
                      >
                        <i v-if="Data.Islightbox" class="fas fas fa-check"></i>
                        <i v-if="!Data.Islightbox" class="fas fas fa-times"></i>
                      </td>

                      <td style="width: 100px; text-align: center">
                        <b-button-group>
                          <b-button
                            variant="success"
                            v-b-modal.news
                            @click="(DataUpdate = Data), (AddEdit = 'Edit')"
                            ><i class="far fa-edit"></i
                          ></b-button>
                          <b-button
                            variant="danger"
                            @click="Delete('news', Data.Id)"
                            ><i class="far fa-trash-alt"></i
                          ></b-button>
                        </b-button-group>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination
                  class="pagination pagination-rounded justify-content-end mb-2"
                  v-model="DefaultPage"
                  :total-rows="Page.PageDataSize"
                  :per-page="Page.PageSize"
                  aria-controls="my-table"
                  @input="ChangePage(DefaultPage)"
                >
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />
    </Layout>
  </Loader>
</template>
